import { createReducer, on } from '@ngrx/store';
import {
  SubAccountsState,
  initialSubAccountsState,
} from './sub-accounts.state';
import * as SubAccountsActions from './sub-accounts.actions';

export const subAccountsReducer = createReducer(
  initialSubAccountsState,

  // Load Sub Accounts
  on(SubAccountsActions.loadSubAccounts, (state) => {
    console.log('SubAccountsReducer: loadSubAccounts - Début du chargement');
    return {
      ...state,
      loading: true,
      error: null,
    };
  }),

  on(SubAccountsActions.loadSubAccountsSuccess, (state, { subAccounts }) => {
    console.log(
      'SubAccountsReducer: loadSubAccountsSuccess - Sous-comptes chargés:',
      subAccounts
    );
    return {
      ...state,
      subAccounts,
      loading: false,
      error: null,
    };
  }),

  on(SubAccountsActions.loadSubAccountsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Add Sub Account
  on(SubAccountsActions.addSubAccount, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(SubAccountsActions.addSubAccountSuccess, (state, { subAccount }) => ({
    ...state,
    subAccounts: [...state.subAccounts, subAccount],
    loading: false,
    error: null,
  })),

  on(SubAccountsActions.addSubAccountFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Update Sub Account
  on(SubAccountsActions.updateSubAccount, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(SubAccountsActions.updateSubAccountSuccess, (state, { subAccount }) => ({
    ...state,
    subAccounts: state.subAccounts.map((account) =>
      account._id === subAccount._id ? subAccount : account
    ),
    loading: false,
    error: null,
  })),

  on(SubAccountsActions.updateSubAccountFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Remove Sub Account
  on(SubAccountsActions.removeSubAccount, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(SubAccountsActions.removeSubAccountSuccess, (state, { subAccountId }) => ({
    ...state,
    subAccounts: state.subAccounts.filter(
      (account) => account._id !== subAccountId
    ),
    loading: false,
    error: null,
  })),

  on(SubAccountsActions.removeSubAccountFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Clear Sub Accounts
  on(SubAccountsActions.clearSubAccounts, (state) => ({
    ...state,
    subAccounts: [],
    loading: false,
    error: null,
  }))
);
